import React, { useEffect, useRef } from 'react';

const DONNA_PHOTO = 'https://customer-assets.emergentagent.com/job_mindful-support-21/artifacts/wrt5r4sy_Donna_new.png';

export default function About() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.15 }
    );
    const el = sectionRef.current;
    if (el) el.querySelectorAll('.reveal').forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="py-24 lg:py-32 bg-white" data-testid="about-section" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 items-center">
          {/* Photo */}
          <div className="reveal flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute -inset-4 bg-[#E6EBE4] rounded-[2.5rem] opacity-60 -z-10" aria-hidden="true" />
              {/* overflow-hidden clips the watermark star at bottom-right */}
              <div className="overflow-hidden rounded-[2rem] w-72 h-72 lg:w-96 lg:h-96 shadow-lg relative z-10">
                <img
                  src={DONNA_PHOTO}
                  alt="Donna Gordon, Psychotherapist"
                  className="w-full h-full object-cover object-[center_25%] scale-[1.02]"
                  data-testid="donna-photo"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="reveal space-y-6">
            <h2 className="font-heading text-4xl md:text-5xl text-[#2C362A] leading-tight">
              About
            </h2>
            <div className="font-body text-base md:text-lg text-[#5B6E56] leading-relaxed space-y-4">
              <p>
                I offer a space where you can begin to understand the deeper story behind the way you see yourself. This exploration will allow us to look at the subtle, often unseen influences that have shaped your sense of self and worth. Together, we will look at the patterns you may find yourself repeating, the emotions that arise unexpectedly, and the inner signals that often point toward unmet needs or unresolved tensions. By bringing thoughtful attention to these deeper layers, you can begin to understand what your inner world has been trying to communicate.
              </p>
              <p>
                My approach is intentional, authentic, and genuinely collaborative. I see the therapeutic relationship as a place of safety and honesty, where trust can develop over time. This creates the foundation for you to rely more on your own sense of clarity and direction, rather than on external influences.
              </p>
            </div>
          </div>
        </div>

        {/* Quote */}
        <div className="mt-16 lg:mt-20 reveal">
          <blockquote className="relative text-center max-w-2xl mx-auto">
            <p className="font-heading text-2xl md:text-3xl lg:text-4xl text-[#2C362A] italic font-light leading-snug px-8">
              What feels hardest to face is often what's ready to change
            </p>
            <div className="mt-6 flex items-center justify-center gap-3">
              <span className="h-px w-8 bg-[#D1D8D0]" />
              <span className="font-body text-xs text-[#708A72]">&copy; Donna Gordon</span>
              <span className="h-px w-8 bg-[#D1D8D0]" />
            </div>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
